<script setup lang="ts">
import CloseButton from '@/components/atoms/CloseButton/CloseButton.vue'
import { inject, onMounted, ref, defineComponent, PropType } from 'vue'

import { onClickOutside, useConfirmDialog } from '@vueuse/core'
const props = withDefaults(defineProps<{
    maxWidth?: string
    width?: string
    dismissible?: boolean
}>(), {
    maxWidth: '600px',
    width: 'calc(100vw - 32px)',
    dismissible: true
})
const emit = defineEmits(['confirm', 'cancel', 'reveal', 'closed', 'modalCancelled'])
const { reveal, confirm, cancel, onReveal, onConfirm, onCancel } = useConfirmDialog()
const modalRef = ref<HTMLDialogElement | null>(null)
const modalContainer = ref<HTMLElement | null>(null)

const eventBus = inject('eventBus');

/*
onClickOutside(modalContainer, () => {
    cancel()
    modalRef.value?.close()
})*/
onReveal(() => {
    emit('reveal')
    modalRef.value?.showModal()
})
function revealDialog() {
    emit('reveal')
    modalRef.value?.showModal()
}

function closeDialog() {
    emit('cancel')
    modalRef.value?.close()
}

function closeDialogWithoutEmit() {
    modalRef.value?.close()
}

function handleNativeCancel(event: Event) {
    if (!props.dismissible) {
        event.preventDefault()
        return
    }

    event.preventDefault()
    emit('cancel')
    modalRef.value?.close()
}

function handleNativeClose() {
    emit('closed')
}


onCancel(() => {
    emit('cancel')
    modalRef.value?.close()
})
onConfirm(() => {
    emit('confirm')

    modalRef.value?.close()
})

defineExpose({
    revealDialog,
    closeDialog,
    closeDialogWithoutEmit
});


eventBus.on("closeDialog", () => {
    modalRef.value?.close();
});

/*
onMounted(() => {

    this.eventBus.on("trigger-a", (param) => {

        modalRef.value?.close();

    });

});
*/

</script>
<template>
    <dialog
        class="custom-modal"
        :style="{
            '--custom-modal-max-width': props.maxWidth,
            '--custom-modal-width': props.width
        }"
        aria-modal="true"
        @close="handleNativeClose"
        @cancel="handleNativeCancel"
        ref="modalRef">
        <CloseButton v-if="props.dismissible" :placement="{ right: '10px', top: '10px' }"
            class="custom-model__close" @close="cancel"></CloseButton>
        <div class="custom-modal__container" ref="modalContainer">
            <slot name="body" :confirm="confirm" :open="reveal"></slot>
        </div>
    </dialog>
    <slot name="button" :open="reveal">
        <!-- <button @click="reveal">open</button>-->
    </slot>
</template>
<style scoped lang="scss">
.custom-modal {
    position: fixed;
    padding: 0;
    border: none;
    max-width: var(--custom-modal-max-width, 600px);
    border-radius: rem(8);
    width: var(--custom-modal-width, calc(100vw - 32px));
    //height: auto;
    max-height: calc(100vh - 32px);
    overflow-y: auto;
    
    &::backdrop {
        background-color: $gray-600;
        opacity: 0.6;
        cursor: pointer;
    }

    &__container {
        border-radius: rem(8);
        overflow-y: visible;
        padding: rem(20);
        padding-bottom: rem(40);
        background-color: $dn-white;
    }
}
</style>
